'use client'

import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

interface EnrollmentData {
  month: string
  enrollments: number
}

interface EnrollmentChartProps {
  data: EnrollmentData[]
}

export default function EnrollmentChart({ data }: EnrollmentChartProps) {
  return (
    <div className="bg-white dark:bg-charcoal-900 rounded-xl p-6 border border-charcoal-200 dark:border-charcoal-800">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-charcoal-900 dark:text-white mb-2">
          Enrollment Trends
        </h3>
        <p className="text-sm text-charcoal-600 dark:text-charcoal-400">
          Monthly course enrollments
        </p>
      </div>
      
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
            <XAxis 
              dataKey="month" 
              className="text-xs"
              tick={{ fill: 'currentColor' }}
            />
            <YAxis 
              className="text-xs"
              tick={{ fill: 'currentColor' }}
            />
            <Tooltip 
              formatter={(value: number) => [value, 'Enrollments']}
              labelStyle={{ color: 'var(--charcoal-900)' }}
              contentStyle={{
                backgroundColor: 'var(--white)',
                border: '1px solid var(--charcoal-200)',
                borderRadius: '8px',
              }}
            />
            <Bar 
              dataKey="enrollments" 
              fill="#3b82f6"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
